module.exports = JSON.parse("{\"timestamp\":\"24.10.2026 - 21:10:46\",\"brands\":[]}")